<template>
  <div class="web swiper-wrapper">
    <div class="swiper-slide page01">
      <div class="page01_bg">
        <img src="../assets/img/web_01bg.png" width="700" alt="" />
      </div>
      <div class="container">
        <div class="text-wapper">
          <div class="logo">
            <img src="../assets/img/logo.png" alt="" />
            <div class="name">
              <h1>定位有术</h1>
              <div class="subtitle">实时定位查询，守护家人安全</div>
            </div>
          </div>
          <div class="down" @click="downloadHandle">安卓下载</div>
          <div class="code">
            <img v-if="!showQcode" src="../assets/img/testqcode.png" alt="" />
            <img v-else src="../assets/img/qcode.png" alt="" />
            <span>扫一扫下载</span>
          </div>
        </div>
        <div class="img-wapper">
          <img src="../assets/img/web_page01.png" width="700" alt="" />
        </div>
      </div>
    </div>
    <div class="swiper-slide page02">
      <div class="page02_bg">
        <img src="../assets/img/web_02bg.png" width="700" alt="" />
      </div>
      <div class="container">
        <div class="img-wapper">
          <img src="../assets/img/web_page02.png" width="700" alt="" />
        </div>
        <div class="text-wapper">
          <h1>实时定位关心的人</h1>
          <div class="subDesc">实时定位查询，守护家人安全</div>
        </div>
      </div>
    </div>
    <div class="swiper-slide page03">
      <div class="page03_bg">
        <img src="../assets/img/web_03bg.png" width="700" alt="" />
      </div>
      <div class="container">
        <div class="text-wapper">
          <h1>历史轨迹</h1>
          <div class="subDesc">精准定位，全程记录</div>
        </div>
        <div class="img-wapper">
          <img src="../assets/img/web_page03.png" width="700" alt="" />
        </div>
      </div>
    </div>
    <div class="swiper-slide page04">
      <div class="container">
        <div class="img-wapper">
          <img src="../assets/img/web_page04.png" width="600" alt="" />
        </div>
        <div class="text-wapper">
          <h1>定制提醒</h1>
          <div class="subDesc">出入地点贴心提醒</div>
        </div>
      </div>
    </div>
    <div class="swiper-slide page05">
      <div class="last-container">
        <div class="container">
          <div class="text-wapper">
            <h1>无限添加</h1>
            <div class="subDesc">好友数量无限制</div>
          </div>
          <div class="img-wapper">
            <img src="../assets/img/web_page05.png" width="700" alt="" />
          </div>
        </div>
      </div>
      <div class="ver">
        Copyright © 2020上海卓悠网络科技有限公司<br /> <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 沪ICP备 14018373号-6</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {showQcode:false};
  },
  mounted() {
    new Swiper("#app", {
      direction: "vertical",
      mousewheel: {
        forceToAxis: false,
        releaseOnEdges: false,
        invert: false,
        sensitivity: 1,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      resistanceRatio: 0, // 滑到第一页和最后一页，不能再往下拉和往上拉
      onSlideChangeEnd: function (swiper) {
        console.log(swiper.activeIndex); //切换结束时，告诉我现在是第几个slide
      },
    });
    if(process.env.NODE_ENV == "development")    this.showQcode = false
    else    this.showQcode = true
    this.getAppApkVersion();
  },
  methods: {
    async getAppApkVersion() {
      let res = await this.$api.getAppApkVersion();
      let data = res.data;
      window.apkUrl = data;
    },
    downloadHandle() {
      if (!window.apkUrl) return;
      window.location.href = window.apkUrl.image_url;
    },
  },
};
</script>


<style lang="less">
html,
body,
#app {
  position: relative;
  height: 100%;
}
body {
  background: #f4f6f8;
  font-family: "微软雅黑", Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: #000;
  margin: 0;
  padding: 0;
}
.swiper-container {
  width: 100%;
  height: 100%;
  min-height: 560px;
}
.swiper-slide {
  position: relative;
}
.web {
  .container {
    max-width: 1200px;
    padding: 0 10px;
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    & > div {
      flex: 1;
      &.text-wapper {
        display: flex;
        align-items: left;
        flex-direction: column;
        justify-content: center;
      }
      &.img-wapper {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .page01 {
    .page01_bg {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      img {
        height: 100%;
      }
    }
    .logo {
      img {
        width: 80px;
        margin-right: 15px;
        vertical-align: top;
      }
      .name {
        display: inline-block;
      }
      h1 {
        font-size: 55px;
      }
      .subtitle {
        font-size: 15px;
        color: #53586c;
        margin-top: 10px;
        letter-spacing: 2px;
      }
    }
    .down {
      margin-top: 68px;
      cursor: pointer;
      margin-bottom: 34px;
      width: 203px;
      height: 45px;
      background: #34dda5;
      border-radius: 23px;
      text-align: center;
      line-height: 45px;
      color: #fff;
      font-size: 20px;
    }
    .code {
      width: 203px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #53586c;
      font-size: 16px;
      letter-spacing: 2px;
      img {
        width: 125px;
        margin-bottom: 13px;
      }
    }
  }
  .page02 {
    .page02_bg {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .page04 {
    background: #e8f4f3;
    .text-wapper {
      align-items: center;
    }
  }
  .page03 {
    .page03_bg {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .text-wapper {
    &:nth-child(2n) {
      text-align: right;
    }
    h1 {
      color: #34dda5;
      font-size: 45px;
      margin-bottom: 23px;
    }
    .subDesc {
      color: #53586c;
      letter-spacing: 3px;
      font-size: 20px;
    }
  }
  .page05 {
    display: flex;
    flex-direction: column;
    .last-container {
      flex: 1;
      overflow: hidden;
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 182px;
        background: url("../assets/img/web_05bg.png") no-repeat;
        background-size: 100% 100%;
        z-index: -1;
      }
    }
    .ver {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 19px;
      font-size: 11px;
      color: #8f97a4;
    }
  }
}
</style>